import { saveAs } from 'file-saver';

import { useApiQuery } from 'theSource/utils';
import { GET_DOWNLOAD_CONFIRMATION_QUERY_KEY } from './utils/constants';
import { base64ToBlob } from 'enrollment/utils/FileUtils/base64blob';

export interface UseAdminRedirectQueryOutput {
  downloadConfirmation: { status: string; data: string };
  isLoadingDownloadConfirmation: boolean;
  isFetchingDownloadConfirmation: boolean;
}

interface UseDownloadConfirmationQueryProps {
  enabled: boolean;
  enrollmentType?: string;
  lumosApiHost: string | undefined;
  orgPlanYearCode: string;
  lifeEventCompleted: boolean;
  onSuccessFn: () => void;
  onErrorFn: () => void;
}

export const useDownloadConfirmationQuery = ({
  enabled,
  enrollmentType,
  lumosApiHost,
  orgPlanYearCode,
  lifeEventCompleted,
  onSuccessFn,
  onErrorFn,
}: UseDownloadConfirmationQueryProps): UseAdminRedirectQueryOutput => {
  const {
    data: downloadConfirmation,
    isLoading: isLoadingDownloadConfirmation,
    isFetching: isFetchingDownloadConfirmation,
  } = useApiQuery<any>({
    queryKey: `${GET_DOWNLOAD_CONFIRMATION_QUERY_KEY}_${orgPlanYearCode}`,
    config: {
      baseURL: `${lumosApiHost}/v2/self_service`,
    },
    endpoint: '/enrollments/confirmation/download',
    enabled: enabled,
    params: {
      enrollment_type: enrollmentType,
      org_plan_year_code: orgPlanYearCode,
      life_event_completed: lifeEventCompleted,
    },
    onSuccess: (data) => {
      const blob = base64ToBlob(data.data);
      if (blob) {
        saveAs(blob, 'confirmation.pdf');
      }
      onSuccessFn();
    },
    onError: () => {
      onErrorFn();
    },
  });

  return {
    downloadConfirmation,
    isLoadingDownloadConfirmation,
    isFetchingDownloadConfirmation,
  };
};
